import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { TooltipOptionItem, TooltipOptionListItem } from '@luigiclaudio/ga-baseline-ui/tooltip';
import { ThemeContext } from 'styled-components';
import { useIntl } from 'react-intl';
import { useFormikContext } from 'formik';
import colorToolsUtils from '../../utils/colorToolsUtils';
import ColorToolsContext from '../context/ColorToolsContext';
import feedbackOnStageUtils from '../../utils/feedbackOnStageUtils';
import FeedbackContext from '../feedbackContext/FeedbackContext';

const ColorTooltipOptionSetMainColor = ({ colorValue, hideTooltip }) => {
    const intl = useIntl();
    const { colorOnStage, setColorOnStage } = useContext(ColorToolsContext);
    const { setFeedbackOnStage } = useContext(FeedbackContext);
    const { setFieldValue } = useFormikContext();
    const theme = useContext(ThemeContext);

    const { setMainColorLabel, setMainColorIcon } = colorToolsUtils.setMainColorLabel(theme, intl);
    const colorValueCode = colorValue.slice(1);

    return (
        <TooltipOptionListItem>
            <TooltipOptionItem
                label={setMainColorLabel}
                icon={setMainColorIcon}
                onClick={() => {
                    setColorOnStage(colorValueCode);
                    setFieldValue('color', colorValueCode);
                    setFeedbackOnStage(feedbackOnStageUtils.setMainColor(colorValue, theme, intl));
                    hideTooltip();
                }}
                disabled={colorValueCode === colorOnStage}
            />
        </TooltipOptionListItem>
    );
};

ColorTooltipOptionSetMainColor.propTypes = {
    colorValue: PropTypes.string.isRequired,
    hideTooltip: PropTypes.func,
};

ColorTooltipOptionSetMainColor.defaultProps = {
    hideTooltip: () => {},
};

export default ColorTooltipOptionSetMainColor;
